import { useQuery } from "@tanstack/react-query";
import type { PartnerLevelsResponse } from "@mfa-aff/shared";
import { levelsMock } from "../mocks/levels";
import { get } from "./client";
import { partnerPaths } from "./paths";

export const levelsKey = ["partner", "levels"] as const;

/** `GET /levels`: the ladder with each level's rates (current + announced) and the plain-language rules. */
export const useLevels = () => useQuery({ queryKey: levelsKey, queryFn: () => get<PartnerLevelsResponse>(partnerPaths.levels, () => levelsMock()) });
